<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <!-- content-header component -->
            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="alert alert-danger p-1" *ngIf="erro">
                {{erro}}
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3 col-6 mb-1">
                            <label>Status</label>
                            <select class="form-control" [(ngModel)]="filtroStatus" (change)="aplicarFiltros()">
                                <option [value]="0">Todos</option>
                                <option [value]="1">Ativo</option>
                                <option [value]="2">Cancelado</option>
                            </select>
                        </div>
                        <div class="col-md-3 col-6 mb-1">
                            <label>Vínculo com cliente</label>
                            <select class="form-control" [(ngModel)]="filtroVinculo" (change)="aplicarFiltros()">
                                <option [value]="0">Todos</option>
                                <option [value]="1">Vinculado</option>
                                <option [value]="2">Não vinculado</option>
                            </select>
                        </div>
                        <div class="col-md-3 col-6 mb-1">
                            <label>Conexão</label>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="filtroNuncaConectou"
                                    [(ngModel)]="filtroNuncaConectou" (change)="aplicarFiltros()" />
                                <label class="custom-control-label" for="filtroNuncaConectou">Nunca conectou</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="filtroSemConexaoXDias"
                                    [(ngModel)]="filtroSemConexaoXDias" (change)="aplicarFiltros()" />
                                <label class="custom-control-label" for="filtroSemConexaoXDias">Mais de X dias sem
                                    conectar</label>
                            </div>
                        </div>
                        <div class="col-md-3 col-6 mb-1" *ngIf="filtroSemConexaoXDias">
                            <label>Dias sem conexão</label>
                            <input type="number" min="1" class="form-control" [(ngModel)]="diasSemConexao"
                                (keyup)="aplicarFiltros()" (change)="aplicarFiltros()" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-6 mb-1">
                            <label>Broker</label>
                            <select class="form-control" [(ngModel)]="filtroBroker" (change)="aplicarFiltros()">
                                <option [value]="0">Todos</option>
                                <option [value]="item.id_broker" *ngFor="let item of brokers">{{item.broker}}</option>
                            </select>
                        </div>
                        <div class="col-md-3 col-6 mb-1">
                            <label>Operadora</label>
                            <select class="form-control" [(ngModel)]="filtroOperadora" (change)="aplicarFiltros()">
                                <option [value]="0">Todas</option>
                                <option [value]="item.id_operadora" *ngFor="let item of operadoras">{{item.operadora}}</option>
                            </select>
                        </div>
                        <div class="col-md-3 col-6 mb-1">
                            <label>ICCID</label>
                            <input type="search" placeholder="ICCID" class="form-control" [(ngModel)]="filtroIccid"
                                (keyup)="aplicarFiltros()" />
                        </div>
                        <div class="col-md-3 col-6 mb-1">
                            <label>Número</label>
                            <input type="search" placeholder="Número" class="form-control" [(ngModel)]="filtroNumero"
                                (keyup)="aplicarFiltros()" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-right">
                            <button class="btn btn-outline-secondary btn-sm mr-1" (click)="limparFiltros()">Limpar
                                filtros</button>
                            <button class="btn btn-success btn-sm" (click)="exportarExcel()"
                                [disabled]="exportando || starting || rows.length == 0"
                                title="Exporta as linhas atualmente filtradas para Excel">
                                <span *ngIf="exportando" class="spinner-border spinner-border-sm mr-50"></span>
                                <span>Exportar Excel<span *ngIf="rows.length > 0"> ({{rows.length}})</span></span>
                            </button>
                        </div>
                    </div>

                    <!-- INDICADORES: total por broker do resultado filtrado (clique filtra por broker) -->
                    <div *ngIf="resumoBrokers.length > 0">
                        <hr>
                        <p class="text-muted mb-50">Total por broker</p>
                        <div class="row">
                            <div class="col-6 col-md-3 col-xl-2 mb-1" *ngFor="let b of resumoBrokers">
                                <div class="card border mb-0 cursor-pointer h-100"
                                    [class.border-primary]="filtroBroker == b.id_broker"
                                    (click)="filtrarPorBroker(b.id_broker)"
                                    title="Clique para filtrar por {{b.broker}}">
                                    <div class="card-body p-1">
                                        <p class="text-muted mb-25">{{b.broker}}</p>
                                        <h3 class="font-weight-bolder mb-25">{{b.qtd | number}}</h3>
                                        <span class="badge badge-pill badge-light-secondary">{{b.pct | number:'1.0-1'}}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- TABELA DE DADOS -->
                <section id="ngx-datatable-inline-editing">

                    <!-- DATATABLE -->
                    <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                        [reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="50"
                        [loadingIndicator]="starting" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

                        <ngx-datatable-column name="ICCID" prop="iccid" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="font-weight-bold">{{row.iccid}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Número" prop="numero" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{row.numero}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Status" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="badge badge-pill badge-light-success" *ngIf="row.status == 1">Ativo</span>
                                <span class="badge badge-pill badge-light-danger" *ngIf="row.status != 1">Cancelado</span>
                                <br>
                                <small class="text-muted">{{row.descricao_status}}</small>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Cliente" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span *ngIf="row.id_cliente && (row.nome_fantasia || row.razao_social)">{{row.nome_fantasia || row.razao_social}}</span>
                                <span class="text-muted" *ngIf="row.id_cliente && !row.nome_fantasia && !row.razao_social">Cliente #{{row.id_cliente}}</span>
                                <span class="badge badge-pill badge-light-warning" *ngIf="!row.id_cliente">Não vinculado</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Broker" prop="broker" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{row.broker}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Operadora" prop="operadora" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{row.operadora}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Dt. Ativação" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span *ngIf="row.dt_ativacao">{{row.dt_ativacao | date:'dd/MM/yyyy':'UTC'}}</span>
                                <span class="text-muted" *ngIf="!row.dt_ativacao">-</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Dt. Conexão" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span *ngIf="row.dt_conexao">{{row.dt_conexao | date:'dd/MM/yyyy':'UTC'}}</span>
                                <span class="text-muted" *ngIf="!row.dt_conexao">Nunca conectou</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Dt. Importação" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                {{row.dt_insert | date:'dd/MM/yyyy HH:mm':'UTC'}}
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>

                    <div class="p-2" *ngIf="!starting && !erro && rows.length == 0">
                        <p class="text-center text-muted mb-0">Nenhum chip importado encontrado para este fechamento.</p>
                    </div>
                </section>

            </div>
        </div>
    </div>
</div>
